import { parseLocalDate } from './dates';
// Date range presets and helpers

export function getRange(preset, custom) {
  const now = new Date();
  const y = now.getFullYear(), m = now.getMonth(); // 0-indexed month

  switch (preset) {
    case 'this-month':
      return { start: fmt(new Date(y, m, 1)), end: fmt(new Date(y, m + 1, 0)), label: monthLabel(y, m) };
    case 'last-month':
      return { start: fmt(new Date(y, m - 1, 1)), end: fmt(new Date(y, m, 0)), label: monthLabel(y, m - 1) };
    case 'this-quarter': {
      const q = Math.floor(m / 3);
      return { start: fmt(new Date(y, q * 3, 1)), end: fmt(new Date(y, q * 3 + 3, 0)), label: `Q${q + 1} ${y}` };
    }
    case 'last-quarter': {
      const q = Math.floor(m / 3) - 1;
      const qy = q < 0 ? y - 1 : y;
      const qq = ((q % 4) + 4) % 4;
      return { start: fmt(new Date(qy, qq * 3, 1)), end: fmt(new Date(qy, qq * 3 + 3, 0)), label: `Q${qq + 1} ${qy}` };
    }
    case 'last-3-months':
      return { start: fmt(new Date(y, m - 2, 1)), end: fmt(new Date(y, m + 1, 0)), label: 'Last 3 Months' };
    case 'ytd':
      return { start: fmt(new Date(y, 0, 1)), end: fmt(now), label: 'Year to Date' };
    case 'this-year':
      return { start: fmt(new Date(y, 0, 1)), end: fmt(new Date(y, 11, 31)), label: String(y) };
    case 'last-year':
      return { start: fmt(new Date(y - 1, 0, 1)), end: fmt(new Date(y - 1, 11, 31)), label: String(y - 1) };
    case 'custom':
      return { start: custom?.start || fmt(new Date(y, m, 1)), end: custom?.end || fmt(now), label: 'Custom Range' };
    default:
      return { start: fmt(new Date(y, m, 1)), end: fmt(new Date(y, m + 1, 0)), label: monthLabel(y, m) };
  }
}

function fmt(d) { return d.toISOString().split('T')[0]; }

function monthLabel(y, m) {
  const d = new Date(y, m, 15);
  return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

export function fmtDateShort(dateStr) {
  if (!dateStr) return '—';
  return parseLocalDate(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function fmtMonthYear(dateStr) {
  if (!dateStr) return '—';
  return parseLocalDate(dateStr).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

export const PRESETS = [
  { id: 'this-month', label: 'This Month' },
  { id: 'last-month', label: 'Last Month' },
  { id: 'this-quarter', label: 'This Quarter' },
  { id: 'last-quarter', label: 'Last Quarter' },
  { id: 'this-year', label: 'This Year' },
  { id: 'last-year', label: 'Last Year' },
  { id: 'custom', label: 'Custom' },
];
